import {FAILURE, REQUEST, SUCCESS} from "./action-type";

export const ACTION_TYPES = {
  LOAD: 'friendList/LOAD',
  CHECK_INVITATIONS: 'friendList/CHECK_INVITATIONS',
  RESET: 'friendList/RESET',
  UNFRIEND: 'friendList/UNFRIEND',
  ACCEPT: 'friendList/ACCEPT',
  DECLINE: 'friendList/DECLINE',
};

const initialState = {
  loading: false,
  totalCount: null,
  data: [[],[]],
  offset: 0,
};

export const sectionIndexByStatus = status => (status > 8 ? 1 : 0);
export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.LOAD):
      if (action.meta.silent) {
        return state;
      }
      return {
        ...state,
        loading: true,
      };
    case SUCCESS(ACTION_TYPES.UNFRIEND):
    case SUCCESS(ACTION_TYPES.DECLINE): {
      const {item} = action.meta;
      const data = [[...state.data[0]], [...state.data[1]]];
      const sectionIndex = sectionIndexByStatus(item.status);
      const index = data[sectionIndex].findIndex(it => it.id === item.id);
      data[sectionIndex].splice(index, 1);
      return {
        ...state,
        data,
        totalCount: state.totalCount - 1,
      };
    }
    case SUCCESS(ACTION_TYPES.LOAD): {
      const {offset, limit, reload} = action.meta;
      const {total_count, friendship_list} = action.payload.data;
      const data = reload ? [[], []] : [[...state.data[0]], [...state.data[1]]];
      friendship_list.forEach(it => {
        data[sectionIndexByStatus(it.status)].push(it);
      });
      return {
        ...state,
        loading: false,
        totalCount: total_count,
        offset: offset + limit,
        data,
      };
    }
    case SUCCESS(ACTION_TYPES.ACCEPT): {
      const {item} = action.meta;

      const data = [...state.data];
      const recInd = data[0].findIndex(it => it.id === item.id);
      data[0].splice(recInd, 1);
      data[1].unshift({...item, status: 9});

      return {
        ...state,
        data,
      };
    }
    case SUCCESS(ACTION_TYPES.CHECK_INVITATIONS): {
      const {offset, limit} = action.meta;
      const {total_count, friendship_list} = action.payload.data;
      const data = [[], []];
      friendship_list.forEach(it => {
        data[sectionIndexByStatus(it.status)].push(it);
      });
      if (state.data[0].length === data[0].length) {
        return state;
      }
      else {
        return {
          ...state,
          totalCount: total_count,
          offset: offset + limit,
          data,
        };
      }
    }
    case FAILURE(ACTION_TYPES.LOAD):
      return {
        ...state,
        loading: false,
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

